import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    name: 'Carlos M.',
    role: 'Chofer de Uber, Houston TX',
    quote: 'Pasé de deber $4,200 a recibir un reembolso de $1,800. Esta guía me cambió la vida. Ojalá la hubiera tenido hace 5 años.',
    stars: 5
  }, {
    name: 'María Elena R.',
    role: 'DoorDash, Los Angeles CA',
    quote: 'Por fin entiendo qué puedo deducir y qué no. Ya no tengo miedo cuando llega abril. Mi preparador de impuestos quedó impresionado.',
    stars: 5
  }, {
    name: 'José Luis P.',
    role: 'Contratista de Construcción, Dallas TX',
    quote: 'Invertí $6.39 y me ahorré más de $3,000 en mi declaración. El capítulo de la oficina en casa vale oro.',
    stars: 5
  }];
  return <section ref={ref} className="bg-[#1a2744] py-20 lg:py-28 relative overflow-hidden" data-id="element-288">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#c9a227]/5 rounded-full blur-3xl" data-id="element-289" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-291">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/20 text-[#c9a227] rounded-full text-sm font-semibold mb-6" data-id="element-292">
            ⭐ Testimonios Reales
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4" data-id="element-293">
            Lo Que Dicen Nuestros{' '}
            <span className="text-[#c9a227]" data-id="element-294">Clientes</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-295">
            Trabajadores como tú que tomaron control de sus impuestos.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-296">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2 + index * 0.15
        }} className="bg-[#243352] rounded-2xl p-8 relative" data-id="element-297">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-[#c9a227]/20" data-id="element-298" />

              <div className="flex gap-1 mb-4" data-id="element-299">
                {[...Array(testimonial.stars)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#c9a227] fill-[#c9a227]" data-id="element-300" />)}
              </div>

              <p className="text-gray-300 mb-6 leading-relaxed italic" data-id="element-301">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-302">
                <div className="w-12 h-12 bg-[#c9a227]/20 rounded-full flex items-center justify-center" data-id="element-303">
                  <span className="text-[#c9a227] font-bold text-lg" data-id="element-304">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-305">
                  <p className="text-white font-semibold" data-id="element-306">{testimonial.name}</p>
                  <p className="text-gray-500 text-sm" data-id="element-307">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="mt-12 text-center" data-id="element-308">
          <p className="text-gray-400" data-id="element-309">
            Más de{' '}
            <strong className="text-[#c9a227]" data-id="element-310">
              500+ trabajadores latinos
            </strong>{' '}
            ya protegen su dinero con El Escudo 1099
          </p>
        </motion.div>
      </div>
    </section>;
}